import gql from 'graphql-tag';

export const DELETE_STORY = gql`
  mutation deleteSaveStoryAction(
    $resourceId: String!
    $auth0User: String
    $communityId: String
    $site: String!
  ) {
    deleteSaveStory(
      input: {
        resourceId: $resourceId
        auth0User: $auth0User
        communityId: $communityId
        site: $site
      }
    ) {
      status
    }
  }
`;

export default DELETE_STORY;
